import index from "./recover.vue";
export default index;
